// extracted by mini-css-extract-plugin
export default {"resetBtn":"ResetButton_resetBtn__vn8sZ"};